module.exports = __webpack_public_path__ + "static/media/DSC_0137-2.a61b468e.jpg";